import { retrieveUserInfo } from '~/actions/salesforce'
import { ACTION_TYPES } from '~/core/constants'

export default store => next => action => {
  switch (action.type) {
    case ACTION_TYPES.SALESFORCE.SET_IS_LOGGED_IN:
      if (action.payload) {
        store.dispatch(retrieveUserInfo())
      }
      next(action)
      break
    default:
      next(action)
  }
}
